import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NombreFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='NOMBRE' htmlFor='input-nombre' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='nombre'>
          {({ field }) => (
            <Form.InputText {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='input-nombre' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NombreFormGroup)
